import { render } from "./tabla_crear_ov.vue?vue&type=template&id=5beaf24b&scoped=true"
import script from "./tabla_crear_ov.vue?vue&type=script&lang=js"
export * from "./tabla_crear_ov.vue?vue&type=script&lang=js"

import "./tabla_crear_ov.vue?vue&type=style&index=0&id=5beaf24b&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Pro-Sistemas08\\OneDrive - PHARMASAN S.A.S\\Documentos\\development\\pharmasan\\new_intranet\\frontend-intv2\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5beaf24b"]])

export default __exports__